// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__3cZiR","content":"LoadingAlert_content__3zGw3"};